var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sidebar-menu'),_c('v-main',[_c('v-container',{staticClass:"mt-10 mx-0 px-2",attrs:{"fluid":""}},[_c('v-layout',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }